import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  confirmButtonText: {
    id: 'jutro-components.modal.AlertModal.confirmButtonText',
    defaultMessage: 'Close'
  }
});